import styled from 'styled-components';
import { ENABLE_OPTION_FLOW_READ_MODE } from 'utils/shared/trades/optionFlowRead';
import { TableRow } from 'components/Table';
import { Button as BaseButton } from 'styles/elements';
import { rgba } from 'styles/utils/color';

export const ViewToggle = styled(BaseButton)<{ isActive: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  width: 72px;
  padding: 0;
  font-size: 10px;
  line-height: 1;
  border: 1px solid
    ${({ theme, isActive }) => (isActive ? theme.color.buttonPrimary : theme.color.border)};
  background-color: ${({ theme, isActive }) =>
    isActive ? theme.color.buttonPrimary : 'transparent'};
  border-radius: 0;
  &:not(:first-of-type) {
    margin-left: -1px;
  }
  &:first-of-type {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }
  &:last-of-type {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  ${({ isActive }) => isActive && `z-index: 1;`}
  &:focus {
    outline: none;
  }
`;

export const IconButton = styled(BaseButton)<{ isActive: boolean }>`
  padding: 0;
  height: 30px;
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  border-width: 1px;
  border-color: ${({ theme, isActive }) =>
    isActive ? theme.color.buttonPrimary : theme.color.border};
  background-color: ${({ theme, isActive }) =>
    isActive ? theme.color.buttonPrimary : theme.color.border};

  &:focus {
    outline: none;
  }
`;

export const DashboardRow = styled(TableRow)<{
  tableBodyRow?: boolean;
  isUnusual?: boolean;
  isGoldenSweep?: boolean;
}>`
  grid-template-columns:
    minmax(56px, 0.9fr) minmax(56px, 1fr) minmax(32px, 0.7fr) minmax(42px, 0.65fr)
    ${ENABLE_OPTION_FLOW_READ_MODE ? 'minmax(88px, 1fr)' : ''} minmax(72px, 1.2fr) minmax(56px, 1fr)
    minmax(48px, 0.8fr)
    minmax(52px, 0.7fr)
    minmax(56px, 1.15fr)
    repeat(7, minmax(56px, 1fr)) 12px;
  background: ${({ isUnusual, isGoldenSweep, theme }) => {
    if (isGoldenSweep) {
      return `linear-gradient(
            -90deg,
            rgba(0, 0, 0, 0) 2%,
            ${rgba(theme.color.mixedSentiment, 0.19)} 32%,
            ${rgba(theme.color.mixedSentiment, 0.14)} 74%,
            rgba(0, 0, 0, 0) 98%);`;
    }

    if (isUnusual) {
      return `linear-gradient(
        -90deg,
        rgba(0, 0, 0, 0) 2%,
        ${rgba(theme.color.unusualTrade, 0.19)} 32%,
        ${rgba(theme.color.unusualTrade, 0.14)} 74%,
        rgba(0, 0, 0, 0) 98%
      )`;
    }

    return 'transparent';
  }};
`;
